// Report with filter
(function ($, undefined){

    'use strict';

    var defaults = {
        tabs: null,
        panels: null
    };



    $.fn.accessibleTabs = function(options) {

        if (this.length === 0) {
            return this;
        }

        if (this.length > 1) {
            this.each(function () {
                $(this).accessibleTabs(options);
            });
            return this;
        }

        var settings = $.extend(true, {}, defaults, options), 
            $el = $(this);


        var plugin = {

            activeItem: 0,
            interval: null,

            _gotoSlide: function() {

                var active = state.slides.removeClass('active').eq( state.current );
                active.addClass('active');

                // Set current color
                if ( active.hasClass('light-colored-text') ) {
                    state.color = 'light-colored-text';
                    $el.removeClass('dark-colored-text').addClass('light-colored-text');
                    settings.siteHeader.removeClass('dark-colored-text').addClass('light-colored-text');
                } else {
                    state.color = 'dark-colored-text';
                    $el.removeClass('light-colored-text').addClass('dark-colored-text');
                    settings.siteHeader.removeClass('light-colored-text').addClass('dark-colored-text');
                }

                if ( state.total > 1 ) {
                    state.navigation.children('li').removeClass('active').eq(state.current).addClass('active');
                }
                

            },

            _setActiveTab: function() {

                settings.tabs.removeClass('selected').eq(plugin.activeItem).addClass('selected');
                settings.panels.attr('aria-hidden', true).eq(plugin.activeItem).attr('aria-hidden', false);

            },

            _handleClick: function( event ) {

                event.preventDefault();

                clearInterval(plugin.interval);

                var target = $(event.target);
                plugin.activeItem = target.index();
                plugin._setActiveTab();
                plugin._setInterval();

            },

            _registerEvents: function() {

                settings.tabs.on('click tap', plugin._handleClick);

            },

            _goToNextSlide: function() {

                if ( plugin.activeItem < settings.tabs.length-1 ) {
                    plugin.activeItem++;
                } else {
                    plugin.activeItem = 0;
                }
                plugin._setActiveTab();

            },

            _setInterval: function() {
                plugin.interval = setInterval(plugin._goToNextSlide, 10000);
            },

            init: function(){


                settings.tabs = $el.find('.tab-navigation a');
                settings.panels = $el.find('.tab-panel');

                plugin._registerEvents();
                plugin._setInterval();

            }

        };
        plugin.init();

        return this;

    };
    $('.accessible-tabs').accessibleTabs();

}(jQuery));



function detectswipe(el,func) {
    
    swipe_det = {};
    swipe_det.sX = 0; swipe_det.sY = 0; swipe_det.eX = 0; swipe_det.eY = 0;
    var min_x = 30;  //min x swipe for horizontal swipe
    var max_x = 30;  //max x difference for vertical swipe
    var min_y = 50;  //min y swipe for vertical swipe
    var max_y = 60;  //max y difference for horizontal swipe
    var direc = "";
    
    ele = document.getElementById(el);
    ele.addEventListener('touchstart',function(e){
        var t = e.touches[0];
        swipe_det.sX = t.screenX; 
        swipe_det.sY = t.screenY;
    },false);
    
    ele.addEventListener('touchmove',function(e){
        e.preventDefault();
        var t = e.touches[0];
        swipe_det.eX = t.screenX; 
        swipe_det.eY = t.screenY;    
    },false);

    ele.addEventListener('touchend',function(e){
        //horizontal detection
        if ((((swipe_det.eX - min_x > swipe_det.sX) || (swipe_det.eX + min_x < swipe_det.sX)) && ((swipe_det.eY < swipe_det.sY + max_y) && (swipe_det.sY > swipe_det.eY - max_y) && (swipe_det.eX > 0)))) {
            if(swipe_det.eX > swipe_det.sX) direc = "r";
            else direc = "l";
        }
        //vertical detection
        else if ((((swipe_det.eY - min_y > swipe_det.sY) || (swipe_det.eY + min_y < swipe_det.sY)) && ((swipe_det.eX < swipe_det.sX + max_x) && (swipe_det.sX > swipe_det.eX - max_x) && (swipe_det.eY > 0)))) {
            if(swipe_det.eY > swipe_det.sY) direc = "d";
            else direc = "u";
        }

        if (direc !== "") {
            if(typeof func == 'function') func(el,direc);
        }
        direc = "";
        swipe_det.sX = 0; swipe_det.sY = 0; swipe_det.eX = 0; swipe_det.eY = 0;
    },false);

}


var jerryogconrad = (function(document, $) {

    'use strict';

    var waypoints = null;
    var docElem = document.documentElement,

        _userAgentInit = function() {
            docElem.setAttribute('data-useragent', navigator.userAgent);
        },

        // Check scrollposition and set header classes
        _scrollHandler = function( ) {

            var scrollTop = $(window).scrollTop(),
                header = $('.site-header'),
                offset = 30;

            if ( scrollTop > offset ) {
                header.addClass('solid');
            } else {
                header.removeClass('solid');
            }

        },

        _registerEvents = function() {

            $(window).on('scroll', _scrollHandler);


            // Toggle site navigation
            $('#site-navigation-toggle').on('click', function( event ) {

                event.preventDefault();

                var $toggle = $(this),
                    $menu = $('#' + $(this).attr('aria-controls')),
                    $allAnchors = $menu.find('ul a'),
                    $toplevelAnchors = $menu.find('ul.top-level > li > a');

                if ($menu.attr('aria-hidden') == 'true') {

                    // Open navigation
                    $('body').addClass('open-navigation');
                    $toggle.attr('aria-expanded', 'true');
                    $menu.attr('aria-hidden', 'false');
                    $toplevelAnchors.attr('tabindex', '0');

                    // Check for open navitem and add children to tabindex
                    if ( $('li.active.parent.open').length > 0 ) {
                        $('li.active.parent.open').find('a').attr('tabindex', '0');
                    }

                } else if ($menu.attr('aria-hidden') == 'false') {

                    // Close navigation
                    $('body').removeClass('open-navigation');
                    $toggle.attr('aria-expanded', 'faremove');
                    $menu.attr('aria-hidden', 'true');
                    $allAnchors.attr('tabindex', '-1');
                    $('li.parent').removeClass('open');

                }

            });


            $('.discover-label span').on('click', function() {

                $('html, body').animate({
                    scrollTop: window.innerHeight
                }, {
                    duration: 1000
                });

            });


            $('.close-child-container').on('click', function() {

                $('.child-container').removeClass('open');

            });


            $('ul.top-level .parent > a').on('click', function( event ) {
                
                event.preventDefault();

                var $childContainer = $('.child-container'),
                    $placeholder = $('.placeholder'),
                    $parent = $(this).closest('.parent'),
                    $children = $(this).next();

                if ( $childContainer.is(':visible') ) {

                    // Handles click on small only

                    $childContainer.addClass('open');
                    $placeholder.empty().append($children.clone());

                } else {

                    // Handles click on medium up

                    // Set negative tabindex for all child links
                    $('ul.children a').attr('tabindex', '-1');

                    if ( $parent.hasClass('open') ) {
                        $parent.removeClass('open');
                    } else {
                        $('li.parent').removeClass('open');
                        $parent.addClass('open');
                        $children.find('a').attr('tabindex', '0');
                    }

                }

                

            });


            $('.share-on-facebook').on('click', function() {
                FB.ui({
                    method: 'share',
                    display: 'popup',
                    href: window.location.href,
                  }, function(response){
                    console.log(response);
                  });
            });


            $('.share-on-twitter').click(function(event) {
                var width  = 575,
                    height = 400,
                    left   = ($(window).width()  - width)  / 2,
                    top    = ($(window).height() - height) / 2,
                    url    = this.href,
                    opts   = 'status=1' +
                             ',width='  + width  +
                             ',height=' + height +
                             ',top='    + top    +
                             ',left='   + left;
                
                window.open(url, 'twitter', opts);
             
                return false;
              });

        },
        

        // Init waypoints for alle elements with the .fade-in class
        _waypoints = function() {

            setTimeout(function() {
                
                if( $('.fade-in').length > 0 ) {

                    waypoints = $('.fade-in').waypoint({
                        handler: function( direction ) {
                            if( direction === 'down' ) {
                                $(this.element).addClass('visible');
                            } else {
                                $(this.element).removeClass('visible');
                            }
                        },
                        offset: '92%'
                    });

                }

                if( $('.fade-in-early').length > 0 ) {

                    waypoints = $('.fade-in-early').waypoint({
                        handler: function( direction ) {
                            if( direction === 'down' ) {
                                $(this.element).addClass('visible');
                            } else {
                                $(this.element).removeClass('visible');
                            }
                        },
                        offset: '100%'
                    });

                }

            }, 200);

        },
        


        _mailchimpSubscribe = function() {

            console.log('_mailchimpSubscribe');

            var $form = $('form#mailchimp-subscribe'),
                $btn = $form.find('button');

            $form.on('submit', function( event ) {

                event.preventDefault();

                $btn.html('Behandler');

                $.post('/', $(this).serialize())
                    .done( function(data) {

                        console.log(data);

                        if (!data.success) {
                            // there was an error, do something with data
                            $btn.html('Feilet');
                        } else {
                            // Success
                            $btn.html('Takk!');
                        }

                    });

            });

        },


        _initSwiper = function() {

            var mySwiper;

            $('.swiper-container').imagesLoaded(function() {
                setTimeout(function() {
                    
                    var mySwiper = new Swiper('.swiper-container', {
                        loop: false,
                        speed: 1000,
                        preventClicks: false,
                        preventClicksPropagation: false,
                        preloadImages: true,
                        updateOnImagesReady: true,
                        navigation: {
                          nextEl: '.swiper-button-next',
                          prevEl: '.swiper-button-prev',
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: false,
                            type: 'custom',
                            renderCustom: function (swiper, current, total) {
                                return current + ' / ' + total;
                            },
                        }
                    });

                }, 100);
            });

        },
        

        _init = function() {
            
            _registerEvents();
            _mailchimpSubscribe();
            _initSwiper();
            _waypoints();

        };

    return {
        init: _init
    };

})(document, jQuery);

(function() {

    'use strict';
    jerryogconrad.init();

})();


// WEBPACK FOOTER //
// ./src/js/bno.js